import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';
import { Bookmark } from '../App';

const RequestBookmarksCommand = Command.extend({}).defaultTo(
  generateDefault({
    action: commandList.REQUEST_BOOKMARKS
  })
);

const PINBookmarkCommand = Command.extend({
  detail: Bookmark
}).defaultTo(
  generateDefault({
    action: commandList.PIN_BOOKMARK
  })
);

const UnPINBookmarkCommand = Command.extend({
  detail: {
    url: String
  }
}).defaultTo(
  generateDefault({
    action: commandList.UNPIN_BOOKMARK
  })
);

const BookmarkUpdateCommand = Command.extend({
  detail: {
    url: String,
    pin: Boolean
  }
}).defaultTo(
  generateDefault({
    action: commandList.BOOKMARK_UPDATE
  })
);

export {
  PINBookmarkCommand,
  UnPINBookmarkCommand,
  RequestBookmarksCommand,
  BookmarkUpdateCommand
};
